import {
    useTranslate,
    useRecordContext,
    useDataProvider,
    useNotify,
    useRefresh,
} from "react-admin";
import { Dialog, Typography } from "@mui/material";
import { handleHttpError } from "shared/src/utils/errorHandler";
import { NumberInput, ReferenceInput, required, SimpleForm } from "react-admin";
import { RaAutocompleteInput } from "../../components/inputs/Ra/RaAutocompleteInput";
import { useState } from "react";
import { SerialNumberField } from "./SerialNumberField";
import { SimpleToolbar } from "../../components/SimpleToolbar";

export const CreateSkuModal = ({ open, onClose, setCreateSkuModalOpen }) => {
    const [serialNumbers, setSerialNumbers] = useState([]);
    const translate = useTranslate();
    const notify = useNotify();
    const refresh = useRefresh();
    const dataProvider = useDataProvider();
    const record = useRecordContext();

    const handleCreateSku = (e) => {
        const requestData = [];

        for (let i = 0; i < serialNumbers.length; i++) {
            requestData.push({
                arrival: record,
                weight: e.weight,
                serialNumber: serialNumbers[i],
                product: { id: record.product.id },
                supplier: { id: record.supplier.id },
                manufacturer: { id: e.manufacturer.id },
                storageLocation: { id: e.storageLocation.id },
            });
        }

        dataProvider
            .createMany("skus", {
                data: requestData,
            })
            .then(() => {
                refresh();
            })
            .catch((e) => {
                handleHttpError(e, notify);
            })
            .finally(() => {
                setCreateSkuModalOpen(false);
                setSerialNumbers([]);
            });
    };

    return (
        <Dialog open={open} fullWidth>
            <Typography variant="h6" sx={{ padding: 2 }}>
                {translate("equip.createSku")}
            </Typography>
            <SimpleForm
                onSubmit={handleCreateSku}
                resource="skus"
                record={{}}
                toolbar={<SimpleToolbar onClose={onClose} />}
            >
                <ReferenceInput
                    source="manufacturer.id"
                    reference="manufacturers"
                    sort={{ field: "name", order: "ASC" }}
                >
                    <RaAutocompleteInput
                        field="name"
                        label="equip.manufacturer"
                        validate={[required()]}
                    />
                </ReferenceInput>
                <ReferenceInput
                    source="storageLocation.id"
                    reference="storageLocations"
                    sort={{ field: "name", order: "ASC" }}
                >
                    <RaAutocompleteInput
                        label="equip.storageLocation"
                        field="name"
                        filterToQuery={(searchText) => ({
                            name: searchText,
                        })}
                    />
                </ReferenceInput>
                <NumberInput
                    title={translate("equip.weight")}
                    label="equip.weight"
                    source="weight"
                />
                <SerialNumberField
                    serialNumbers={serialNumbers}
                    setSerialNumbers={setSerialNumbers}
                    required
                />
            </SimpleForm>
        </Dialog>
    );
};
